import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeTimeframe } from 'actions';
import AnalyticsDateRangePicker from '../../search/analytic/components/AnalyticsDateRangePicker';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import asyncComponent from 'util/asyncComponent';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import Conversion from './Conversion';
import PopularProducts from './PopularProducts';

const StoreAnalytics = ({ match }) => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { analytics: { timeframe } } = useSelector((store) => store);

  const onTimeframeSubmit = (newRange) => dispatch(changeTimeframe(newRange));

  const timeframePicker = (
    <AnalyticsDateRangePicker
      timeframe={timeframe}
      onSubmitRange={onTimeframeSubmit}
    />
  );

  return (
    <FeaturePageShell
      title={localizeMessage('sidebar.store.analytics')}
      description={localizeMessage('store.analytics.description')}
      actions={timeframePicker}
      width="expanded"
    >
      <Switch>
        <Route path={`${match.url}/conversion`} component={Conversion} />
        <Route path={`${match.url}/popular-products`} component={PopularProducts} />

        <Route component={asyncComponent(() => import('app/routes/404'))} />
      </Switch>
    </FeaturePageShell>
  );
};

export default StoreAnalytics;
